import RoboChat from '../../../../icons/RoboChat.svg?react';
import { EasyStepsConfirmationData, EasyStepsScheduleData } from "../../Common/Appointment/CustomAppointmentData";

export const EasyStepsSchedule = EasyStepsScheduleData;

export const EasyStepsConfirmation = EasyStepsConfirmationData;

export const InsurancePlan = [
  {
    title: "Need Help?",
    content: "Getting your spouse or partner insured can be just as important as your own insurance.",
    icon: RoboChat,
    btnTitle: 'GET A QUOTE',
    linkTo: '/landing/final-expense'
  },
  {
    title: "Other Insurance Options",
    content: "Explore coverage options in a variety of categories, all from your mobile device.",
    icon: RoboChat,
    btnTitle: 'SEE PRODUCTS',
    linkTo: '/'
  },
  {
    title: "Policy Review",
    content: "Save money on your existing insurance policies with a free no obligations policy review.",
    icon: RoboChat,
    btnTitle: 'GET A POLICY REVIEW',
    linkTo: '/policy-review'
  },
];
